module.exports = __webpack_public_path__ + "static/guerrilla-marketing-for-writers-09139b78db1fcfe9da7773a260d45e84.jpg";